var _g, _rect, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgLanding01Large(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 452,
    height: 618,
    viewBox: "0 0 452 618",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_1698)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_di_1_1698)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 432,
    height: 598,
    rx: 32,
    fill: "#E9F4FF",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4062 72.9102V75.3711H48.8203V72.9102H58.5V67.1953H61.5078V72.9102H71.4062ZM49.4766 65.2812C54.6445 64.4473 58.3496 60.7422 58.3633 57.0234V55.2188H61.5898V57.0234C61.5898 60.7559 65.3223 64.4473 70.5312 65.2812L69.2188 67.7969C65.0488 67.0039 61.6172 64.6113 59.9766 61.3711C58.3496 64.5977 54.959 67.0176 50.7891 67.7969L49.4766 65.2812ZM86.8828 56.1758V58.582H73.0742V56.1758H78.5977V53.4961H81.6328V56.1758H86.8828ZM74.3594 64.1875C74.3457 61.4258 76.6973 59.5664 80.0742 59.5664C83.4375 59.5664 85.8574 61.4258 85.8711 64.1875C85.8574 66.9355 83.4375 68.7539 80.0742 68.7539C76.6973 68.7539 74.3457 66.9355 74.3594 64.1875ZM76.957 74.1133C76.957 71.3926 80.1699 69.8066 85.4062 69.8203C90.6289 69.8066 93.8418 71.3926 93.8555 74.1133C93.8418 76.793 90.6289 78.4062 85.4062 78.4062C80.1699 78.4062 76.957 76.793 76.957 74.1133ZM77.2031 64.1875C77.1895 65.6367 78.3242 66.4844 80.0742 66.4844C81.8242 66.4844 83.0273 65.6367 83.0273 64.1875C83.0273 62.7109 81.8242 61.8359 80.0742 61.8359C78.3242 61.8359 77.1895 62.7109 77.2031 64.1875ZM80.1562 74.1133C80.1426 75.3984 82.0703 76.0957 85.4062 76.082C88.7148 76.0957 90.6016 75.3984 90.6016 74.1133C90.6016 72.8008 88.7148 72.1445 85.4062 72.1445C82.0703 72.1445 80.1426 72.8008 80.1562 74.1133ZM87.0195 66.6484V64.2148H90.6836V61.7812H87.0469V59.3203H90.6836V53.7148H93.7188V69.5469H90.6836V66.6484H87.0195ZM117.781 53.7148V78.4609H114.719V53.7148H117.781ZM98.0117 64.2422C97.998 58.9102 100.719 55.5195 104.465 55.5195C108.17 55.5195 110.904 58.9102 110.918 64.2422C110.904 69.6152 108.17 72.9922 104.465 72.9922C100.719 72.9922 97.998 69.6152 98.0117 64.2422ZM100.938 64.2422C100.938 68.043 102.373 70.2441 104.465 70.2578C106.543 70.2441 107.965 68.043 107.965 64.2422C107.965 60.4688 106.543 58.2539 104.465 58.2539C102.373 58.2539 100.938 60.4688 100.938 64.2422ZM130.25 59.6484C130.223 64.0645 132.438 68.5215 136.266 70.3672L134.406 72.8008C131.727 71.4473 129.799 68.8359 128.746 65.6914C127.666 69.0547 125.643 71.8438 122.812 73.2656L120.953 70.832C124.932 68.9453 127.201 64.2148 127.215 59.6484V55.7109H130.25V59.6484ZM137.742 78.4336V53.7148H140.777V63.3945H144.578V65.9922H140.777V78.4336H137.742Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0195 102.238V115.422H61.4766V113.625H57.8828V112.512H61.4766V102.238H63.0195ZM63.4492 117.922V119.211H51.1055V114.133H52.6484V117.922H63.4492ZM48.6055 110.285C51.8477 110.266 56.1836 110.246 59.9141 109.777L60.0117 110.891C58.459 111.135 56.8379 111.291 55.2461 111.379V114.816H53.7031V111.457C51.9453 111.535 50.2754 111.545 48.8203 111.535L48.6055 110.285ZM54.3086 102.941C56.8477 102.941 58.5859 104.152 58.6055 105.969C58.5859 107.824 56.8477 108.977 54.3086 108.977C51.75 108.977 50.0117 107.824 50.0117 105.969C50.0117 104.152 51.75 102.941 54.3086 102.941ZM54.3086 104.113C52.6094 104.094 51.457 104.855 51.4766 105.969C51.457 107.102 52.6094 107.844 54.3086 107.844C55.9492 107.844 57.1211 107.102 57.1406 105.969C57.1211 104.855 55.9492 104.094 54.3086 104.113ZM81.8672 111.047V112.297H74.6602V114.113H79.8164V119.348H68.1367V114.113H73.1562V112.297H65.9688V111.047H81.8672ZM69.6406 115.344V118.098H78.3125V115.344H69.6406ZM79.8164 102.648V106.711H69.5625V108.449H80.1875V109.68H68.0391V105.578H78.2734V103.84H67.9805V102.648H79.8164ZM86.125 116.691L84.6016 122.004H83.1562L84.2305 116.691H86.125ZM109.289 112.746V114.016H102.062V119.582H100.559V114.016H93.3906V112.746H109.289ZM107.492 109.699V110.949H95.5195V103.039H107.297V104.289H97.043V106.32H106.887V107.551H97.043V109.699H107.492ZM126.574 111.047V112.297H119.367V114.113H124.523V119.348H112.844V114.113H117.863V112.297H110.676V111.047H126.574ZM114.348 115.344V118.098H123.02V115.344H114.348ZM124.523 102.648V106.711H114.27V108.449H124.895V109.68H112.746V105.578H122.98V103.84H112.688V102.648H124.523ZM130.832 116.691L129.309 122.004H127.863L128.938 116.691H130.832ZM138.742 118L138.723 116.711L143.547 111.633C145.227 109.855 146.027 108.898 146.027 107.59C146.027 106.145 144.797 105.188 143.215 105.188C141.535 105.188 140.461 106.262 140.461 107.844H138.801C138.781 105.344 140.715 103.664 143.273 103.664C145.832 103.664 147.668 105.383 147.668 107.59C147.668 109.172 146.926 110.402 144.426 112.98L141.184 116.32V116.438H147.922V118H138.742ZM155.109 118.195C151.965 118.195 150.168 115.559 150.168 110.93C150.168 106.34 152.004 103.664 155.109 103.664C158.215 103.664 160.051 106.34 160.051 110.93C160.051 115.559 158.234 118.195 155.109 118.195ZM155.109 116.633C157.141 116.633 158.332 114.582 158.332 110.93C158.332 107.277 157.141 105.188 155.109 105.188C153.078 105.188 151.867 107.277 151.867 110.93C151.867 114.582 153.059 116.633 155.109 116.633ZM171.516 103.547V104.816H169.738V110.363C170.549 110.314 171.33 110.246 172.082 110.148L172.16 111.32C168.781 111.848 164.816 111.887 162.004 111.887L161.809 110.598C162.502 110.598 163.254 110.598 164.055 110.578V104.816H162.297V103.547H171.516ZM176.164 102.219V112.941H174.621V109.719H171.691V108.449H174.621V106.613H171.691V105.344H174.621V102.219H176.164ZM170.402 113.312C174.035 113.312 176.223 114.445 176.223 116.418C176.223 118.41 174.035 119.543 170.402 119.543C166.77 119.543 164.582 118.41 164.582 116.418C164.582 114.445 166.77 113.312 170.402 113.312ZM170.402 114.504C167.727 114.504 166.086 115.227 166.105 116.418C166.086 117.629 167.727 118.332 170.402 118.332C173.078 118.332 174.699 117.629 174.699 116.418C174.699 115.227 173.078 114.504 170.402 114.504ZM165.539 110.559C166.428 110.539 167.346 110.51 168.254 110.461V104.816H165.539V110.559ZM193.898 102.219V119.582H192.434V110.48H189.875V118.684H188.469V102.609H189.875V109.211H192.434V102.219H193.898ZM186.203 104.348V105.617H181.223V113.977C183.615 113.967 185.275 113.879 187.199 113.488L187.336 114.777C185.246 115.207 183.469 115.285 180.812 115.285H179.699V104.348H186.203ZM210.402 103.938V115.227H202.375V103.938H210.402ZM203.879 105.168V113.977H208.898V105.168H203.879ZM215.676 102.219V119.621H214.133V102.219H215.676ZM227.414 103.801V111.789H219.387V103.801H227.414ZM220.891 105.051V110.559H225.93V105.051H220.891ZM232.219 102.219V107.512H234.836V108.801H232.219V114.953H230.695V102.219H232.219ZM233.02 117.922V119.211H221.359V113.742H222.863V117.922H233.02Z",
    fill: "#999999"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_1698",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 432,
    height: 598
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 432,
    height: 598,
    rx: 32,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_1698)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M266.081 430.636C348.863 400.395 437.589 351.566 498 309.2L549.55 273.048C553.791 270.074 559.6 273.125 559.6 278.305V429.062C559.6 431.154 558.571 433.121 556.847 434.305C442.175 513.033 303.86 527.441 286.4 507.6C273.512 492.955 265.227 457.533 261.973 437.529C261.487 434.539 263.236 431.675 266.081 430.636Z",
    fill: "#4DA9FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.599,
    y: 512.4,
    width: 32,
    height: 38.4,
    rx: 12.8,
    fill: "#242945"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246.799,
    y: 512.4,
    width: 32,
    height: 38.4,
    rx: 12.8,
    fill: "#242945"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.9993,
    y: 339.6,
    width: 214.4,
    height: 192,
    rx: 6.4,
    fill: "#F96C44"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.7993,
    y: 352.4,
    width: 196.8,
    height: 76.8,
    rx: 6.4,
    fill: "#F78956"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.7993,
    y: 442,
    width: 196.8,
    height: 76.8,
    rx: 6.4,
    fill: "#F78956"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.599,
    y: 402.799,
    width: 107.2,
    height: 52.8,
    rx: 3.2,
    fill: "#F7C056"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.799,
    y: 474.799,
    width: 44.8,
    height: 12.8,
    rx: 3.2,
    fill: "#F96C44"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.21 499.596C212.331 499.947 171.626 505.874 155.794 527.44C154.187 530.074 152.698 534.802 154.484 539.259C147.247 543.29 141.366 550.487 151.162 560.5C154.676 564.093 168.362 565.632 187.808 565.632C189.206 565.908 190.751 566.26 192.44 566.645C207.19 570.007 232.829 575.85 266 554.512V524.4H258.397C258.212 523.89 257.911 523.408 257.486 522.989L234.911 500.692C234.189 499.98 233.223 499.578 232.21 499.596Z",
    fill: "#F4C7A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.8 538.801C159.565 541.819 168.4 547.601 193.2 538.801",
    stroke: "#ECB087",
    strokeWidth: 3.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.899 494.335L244.866 491.188C247.737 490.491 250.712 491.85 252.065 494.477L281.139 550.919C282.881 554.301 281.305 558.465 277.697 559.668C264.711 563.997 256.164 564.685 251.933 564.313C250.506 564.187 249.303 563.287 248.5 562.1C229.529 534.053 227.547 514.017 226.994 500.815C226.867 497.767 228.934 495.055 231.899 494.335Z",
    fill: "#E9F4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.081 485.036C328.863 454.796 417.589 405.966 478 363.6L529.55 327.448C533.791 324.474 539.6 327.525 539.6 332.706V483.462C539.6 485.554 538.571 487.522 536.847 488.706C422.175 567.433 283.86 581.841 266.4 562C253.512 547.356 245.227 511.934 241.973 491.929C241.487 488.939 243.236 486.076 246.081 485.036Z",
    fill: "#1B92FF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_1698",
    x: 0,
    y: 0,
    width: 452,
    height: 618,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.881852 0 0 0 0 0.881852 0 0 0 0 0.881852 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_1698"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_1698",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_di_1_1698",
    x: 0,
    y: 0,
    width: 452,
    height: 618,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.881852 0 0 0 0 0.881852 0 0 0 0 0.881852 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_1698"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_1698",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.958805 0 0 0 0 0.958805 0 0 0 0 0.958805 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_1_1698"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgLanding01Large);
export default __webpack_public_path__ + "static/media/img_landing_01_large.2122083abe94ed0d3c2dda58fada5fdf.svg";
export { ForwardRef as ReactComponent };